package com.anjuros.website.templates.template2.util

import com.anjuros.website.components.language.Language
import com.anjuros.website.components.language.ResKeyType


enum class ResKey: ResKeyType {




    TEMPLATE2_REVIEW1_TITLE,
    TEMPLATE2_REVIEW1,
    TEMPLATE2_REVIEW2_TITLE,
    TEMPLATE2_REVIEW2,
    TEMPLATE2_REVIEW3_TITLE,
    TEMPLATE2_REVIEW3,
    TEMPLATE2_REVIEW4_TITLE,
    TEMPLATE2_REVIEW4,
    TEMPLATE2_REVIEW5_TITLE,
    TEMPLATE2_REVIEW5,
    TEMPLATE2_REVIEW6_TITLE,
    TEMPLATE2_REVIEW6,
    TEMPLATE2_REVIEW7_TITLE,
    TEMPLATE2_REVIEW7,
    TEMPLATE2_REVIEW8_TITLE,
    TEMPLATE2_REVIEW8,
    TEMPLATE2_REVIEW9_TITLE,
    TEMPLATE2_REVIEW9,
    TEMPLATE2_REVIEW10_TITLE,
    TEMPLATE2_REVIEW10,
    TEMPLATE2_CONTACT,
    TEMPLATE2_CONTACT_QUOTE,
    TEMPLATE2_CONTACT_MAIL,
    TEMPLATE2_CONTACT_CALL,


    TEMPLATE2_CONTACT_DROPDOWN1,
    TEMPLATE2_CONTACT_DROPDOWN2,
    TEMPLATE2_CONTACT_DROPDOWN3,

    TEMPLATE2_HERO_BADGE,
    
    TEMPLATE2_HERO_TITLE,
    TEMPLATE2_HERO_TITLE2,

    TEMPLATE2_HERO_DESCRIPTION,

    TEMPLATE2_HERO_PRIMARY_BUTTON,
    TEMPLATE2_HERO_SECONDARY_BUTTON,

    TEMPLATE2_HERO_BADGE1,
    TEMPLATE2_HERO_BADGE1_DESC,

    TEMPLATE2_HERO_BADGE2,
    TEMPLATE2_HERO_BADGE2_DESC,

    TEMPLATE2_HERO_BADGE3,
    TEMPLATE2_HERO_BADGE3_DESC,



    TEMPLATE2_SERVICE1_TITLE,
    TEMPLATE2_SERVICE1_DESC1,

    TEMPLATE2_SERVICE2_TITLE,
    TEMPLATE2_SERVICE2_DESC1,

    TEMPLATE2_SERVICE3_TITLE,
    TEMPLATE2_SERVICE3_DESC1,

    TEMPLATE2_SERVICE4_TITLE,
    TEMPLATE2_SERVICE4_DESC1,

    TEMPLATE2_SERVICE5_TITLE,
    TEMPLATE2_SERVICE5_DESC1,

    TEMPLATE2_SERVICE6_TITLE,
    TEMPLATE2_SERVICE6_DESC1,


    TEMPLATE2_WHY_CHOOSE_TITLE,
    TEMPLATE2_WHY_CHOOSE_DESCRIPTION,

    TEMPLATE2_INFO_TITLE1,
    TEMPLATE2_INFO_DESC1,

    TEMPLATE2_INFO_TITLE2,
    TEMPLATE2_INFO_DESC2,

    TEMPLATE2_INFO_TITLE3,
    TEMPLATE2_INFO_DESC3,

    TEMPLATE2_INFO_TITLE4,
    TEMPLATE2_INFO_DESC4,

    TEMPLATE2_ACHIEVEMENT1_NUMBER,
    TEMPLATE2_ACHIEVEMENT1,

    TEMPLATE2_ACHIEVEMENT2_NUMBER,
    TEMPLATE2_ACHIEVEMENT2,

    TEMPLATE2_ACHIEVEMENT3_NUMBER,
    TEMPLATE2_ACHIEVEMENT3,

    TEMPLATE2_ACHIEVEMENT4_NUMBER,
    TEMPLATE2_ACHIEVEMENT4,


    TEMPLATE2_CONTACT_BADGE,
    TEMPLATE2_CONTACT_TITLE,
    TEMPLATE2_CONTACT_TEXT,

    TEMPLATE2_CONTACT_CARD_TITLE,
    TEMPLATE2_CONTACT_CARD_SUBTITLE,
    TEMPLATE2_CONTACT_CARD_FOOTER,


    TEMPLATE2_SERVICE_TITLE,
    TEMPLATE2_SERVICE_DESC,

    TEMPLATE2_REVIEWS_TITLE,
    TEMPLATE2_REVIEWS_DESC,

    TEMPLATE2_SECTION1,
    TEMPLATE2_SECTION2,
    TEMPLATE2_SECTION3
    ;


    override val keyName: String
        get() = name


}


// 4. A map to hold all translations, keyed by language
val TextResources = mapOf(
    Language.EN to mapOf(

        ResKey.TEMPLATE2_SECTION1 to "Our Services",
        ResKey.TEMPLATE2_SECTION2 to "Reviews",
        ResKey.TEMPLATE2_SECTION3 to "Contact me",


        ResKey.TEMPLATE2_REVIEW1_TITLE to "Kitchen Tap Replacement",
        ResKey.TEMPLATE2_REVIEW1 to "Very impressed with the quality of work and professionalism. My old kitchen tap was leaking badly, and James came in, assessed the situation, and had it replaced in under an hour. He even cleaned up afterward, which I really appreciated. Highly recommend for any plumbing-related tasks.",
        ResKey.TEMPLATE2_REVIEW2_TITLE to "TV Wall Mount Installation",
        ResKey.TEMPLATE2_REVIEW2 to "Great experience! James mounted our new 65” TV securely and made sure all the cables were hidden neatly. He was punctual, polite, and double-checked that we were happy with the height and placement. Will definitely use him again.",
        ResKey.TEMPLATE2_REVIEW3_TITLE to "Drywall Repair in Living Room",
        ResKey.TEMPLATE2_REVIEW3 to "We had a big hole in our drywall from a previous plumbing issue, and James patched it perfectly. You’d never know it was damaged. The texture and paint match exactly. A very clean and professional job, worth every penny.",
        ResKey.TEMPLATE2_REVIEW4_TITLE to "Bathroom Caulking Redone",
        ResKey.TEMPLATE2_REVIEW4 to "Our bathroom was starting to show signs of mold and cracking in the caulk lines, and James did an excellent job removing the old stuff and applying new caulk. It looks brand new and feels sealed properly. Friendly and respectful throughout the process.",
        ResKey.TEMPLATE2_REVIEW5_TITLE to "Deck Repairs and Staining",
        ResKey.TEMPLATE2_REVIEW5 to "Our backyard deck had several loose boards and was in dire need of staining. James came out, reinforced the structure, replaced some rotted planks, and stained it all in a beautiful finish. Now it looks amazing and feels sturdy. Very happy with the result!",
        ResKey.TEMPLATE2_REVIEW6_TITLE to "Light Fixture Installation",
        ResKey.TEMPLATE2_REVIEW6 to "We had two outdated fixtures that needed to go, and James replaced both with sleek new ones in no time. He made sure the electrical work was safe and up to code. He even cleaned up the old packaging and debris. Super courteous and skilled.",
        ResKey.TEMPLATE2_REVIEW7_TITLE to "Door Frame and Lock Fix",
        ResKey.TEMPLATE2_REVIEW7 to "Our front door wouldn’t close properly, and the lock was sticking. James adjusted the frame, realigned the strike plate, and now it shuts and locks perfectly. A small job, but done with care and attention. Very affordable too.",
        ResKey.TEMPLATE2_REVIEW8_TITLE to "Fence Gate Replacement",
        ResKey.TEMPLATE2_REVIEW8 to "The old gate to our backyard was falling apart. James came in, removed it, and built a custom gate that fits perfectly and looks better than the original. He took time to stain it and made sure it swings smoothly. Quality craftsmanship!",
        ResKey.TEMPLATE2_REVIEW9_TITLE to "Hanging Curtains and Blinds",
        ResKey.TEMPLATE2_REVIEW9 to "This could’ve been a frustrating DIY, but James made it easy. He measured carefully, installed all the rods and brackets securely, and everything is perfectly level. He was also really neat and left no mess behind. Great work!",
        ResKey.TEMPLATE2_REVIEW10_TITLE to "Assembling Furniture Set",
        ResKey.TEMPLATE2_REVIEW10 to "I had several pieces of flat-pack furniture I needed assembled: dresser, nightstands, and a bookshelf. James was efficient and careful, followed all instructions, and the final result is sturdy and aligned. Saved me hours of frustration!",

        ResKey.TEMPLATE2_CONTACT to "Contact",
        ResKey.TEMPLATE2_CONTACT_QUOTE to "Get in touch to receive a free quote!",
        ResKey.TEMPLATE2_CONTACT_MAIL to "Mail me",
        ResKey.TEMPLATE2_CONTACT_CALL to "Call me",


        ResKey.TEMPLATE2_CONTACT_DROPDOWN1 to "ASAP",
        ResKey.TEMPLATE2_CONTACT_DROPDOWN2 to "Within a week",
        ResKey.TEMPLATE2_CONTACT_DROPDOWN3 to "Flexible",

        ///////////////////
        ResKey.TEMPLATE2_HERO_BADGE to "Reliable. Skilled. Local.",
        ResKey.TEMPLATE2_HERO_TITLE to "Handyman Services",
        ResKey.TEMPLATE2_HERO_TITLE2 to "Done Right.",
        ResKey.TEMPLATE2_HERO_DESCRIPTION to "From small repairs to full renovations, we deliver high-quality workmanship with honesty and care.",

        ResKey.TEMPLATE2_HERO_PRIMARY_BUTTON to "Get a Free Quote",
        ResKey.TEMPLATE2_HERO_SECONDARY_BUTTON to "See Our Work",

        ResKey.TEMPLATE2_HERO_BADGE1 to "Fully Insured",
        ResKey.TEMPLATE2_HERO_BADGE1_DESC to "Peace of mind",

        ResKey.TEMPLATE2_HERO_BADGE2 to "On Time",
        ResKey.TEMPLATE2_HERO_BADGE2_DESC to "We respect your time",

        ResKey.TEMPLATE2_HERO_BADGE3 to "Quality Guaranteed",
        ResKey.TEMPLATE2_HERO_BADGE3_DESC to "Work you can trust",
        ResKey.TEMPLATE2_SERVICE_TITLE to "Quality Handyman Services for Every Home",

        ResKey.TEMPLATE2_SERVICE1_TITLE to "Plumbing",
        ResKey.TEMPLATE2_SERVICE1_DESC1 to "From leaking taps and blocked sinks to pipe repairs and fixture installations, we provide reliable plumbing solutions to keep your home running smoothly.",

        ResKey.TEMPLATE2_SERVICE2_TITLE to "Electrics",
        ResKey.TEMPLATE2_SERVICE2_DESC1 to "Safe and professional electrical services, including lighting installation, socket replacements, switches and other small electrical jobs around your home.",

        ResKey.TEMPLATE2_SERVICE3_TITLE to "Tiling",
        ResKey.TEMPLATE2_SERVICE3_DESC1 to "Expert wall and floor tiling for kitchens, bathrooms and living spaces, delivering clean lines, durable finishes and attention to every detail.",

        ResKey.TEMPLATE2_SERVICE4_TITLE to "Carpentry",
        ResKey.TEMPLATE2_SERVICE4_DESC1 to "From fitting doors and skirting boards to bespoke shelving and general woodwork, we deliver quality craftsmanship built to last.",

        ResKey.TEMPLATE2_SERVICE5_TITLE to "Property Maintenance",
        ResKey.TEMPLATE2_SERVICE5_DESC1 to "Keep your property in excellent condition with dependable maintenance services, preventative repairs and ongoing home improvements.",

        ResKey.TEMPLATE2_SERVICE6_TITLE to "General Repairs",
        ResKey.TEMPLATE2_SERVICE6_DESC1 to "No job is too small. We handle all those everyday repairs around your home quickly, professionally and with great attention to detail.",
        ResKey.TEMPLATE2_WHY_CHOOSE_TITLE to "Reliable Workmanship You Can Count On",
        ResKey.TEMPLATE2_WHY_CHOOSE_DESCRIPTION to "We take pride in delivering high-quality handyman services with clear communication, honest pricing and attention to every detail.",

        ResKey.TEMPLATE2_INFO_TITLE1 to "Experienced Professionals",
        ResKey.TEMPLATE2_INFO_DESC1 to "Years of practical experience across a wide range of home improvement projects.",

        ResKey.TEMPLATE2_INFO_TITLE2 to "Honest & Transparent",
        ResKey.TEMPLATE2_INFO_DESC2 to "Clear pricing, dependable advice and no unexpected surprises.",

        ResKey.TEMPLATE2_INFO_TITLE3 to "Quality Guaranteed",
        ResKey.TEMPLATE2_INFO_DESC3 to "We complete every job to a high standard using quality materials and proven techniques.",

        ResKey.TEMPLATE2_INFO_TITLE4 to "Friendly Local Service",
        ResKey.TEMPLATE2_INFO_DESC4 to "A reliable handyman who arrives on time, treats your home with respect and keeps you informed throughout the job.",

        ResKey.TEMPLATE2_ACHIEVEMENT1_NUMBER to "15+",
        ResKey.TEMPLATE2_ACHIEVEMENT1 to "Years Experience",

        ResKey.TEMPLATE2_ACHIEVEMENT2_NUMBER to "500+",
        ResKey.TEMPLATE2_ACHIEVEMENT2 to "Projects Completed",

        ResKey.TEMPLATE2_ACHIEVEMENT3_NUMBER to "100%",
        ResKey.TEMPLATE2_ACHIEVEMENT3 to "Customer Focus",

        ResKey.TEMPLATE2_ACHIEVEMENT4_NUMBER to "5★",
        ResKey.TEMPLATE2_ACHIEVEMENT4 to "Rated Service",

        ResKey.TEMPLATE2_CONTACT_BADGE to "GET IN TOUCH",

        ResKey.TEMPLATE2_CONTACT_TITLE to "Let's Discuss Your Project",

        ResKey.TEMPLATE2_CONTACT_TEXT to "Tell us a little about your project and we'll get back to you as soon as possible.",

        ResKey.TEMPLATE2_CONTACT_CARD_TITLE to "TrueBuild Handyman Ltd",

        ResKey.TEMPLATE2_CONTACT_CARD_SUBTITLE to "Reliable home repairs, maintenance and improvements across Stafford and the surrounding areas.",

        ResKey.TEMPLATE2_CONTACT_CARD_FOOTER to "Fully insured • Friendly service • Quality workmanship",



        ResKey.TEMPLATE2_SERVICE_TITLE to "Quality Handyman Services for Every Home",

        ResKey.TEMPLATE2_SERVICE_DESC to "From everyday repairs to home improvements, we provide reliable workmanship and friendly service to help keep your home in great condition.",



        ResKey.TEMPLATE2_REVIEWS_TITLE to "Trusted by Homeowners Across the Local Area",

        ResKey.TEMPLATE2_REVIEWS_DESC to "We're proud to deliver quality workmanship and dependable service. Here's what some of our happy customers have to say about working with TrueBuild.",

        ),
)
